var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"globalAd"},[_c('myMaks',{staticStyle:{"background":"rgba(0,0,0,.75)"}}),_vm._v(" "),_c('scrollview',{staticClass:"globalAd-wrapper"},[_c('ul',{class:[_vm.channelId == 105 ?'globalAd-pic-other':'globalAd-pic']},[_c('v-touch',{staticClass:"cancel-icon",on:{"tap":_vm.cancel}},[_c('img',{attrs:{"src":require("../../assets/activity/1212/btn_close.png")}})]),_vm._v(" "),_c('v-touch',{staticClass:" confirm",on:{"tap":_vm.confirm}},[_vm._v("马上购买")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/promotion/global_ad.vue?vue&type=template&id=4fb340d3&
// module id = null
// module chunks = 